import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react'
import SelectBox from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import {  DataGrid,  Popup} from 'devextreme-react';
import React from 'react';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { toast } from 'react-toastify';


function getDayName(id: number): string | undefined {
  const gunler = [
    { id: 1, name:t('syncflow:orderday_01') },
    { id: 2, name: t('syncflow:orderday_02') },
    { id: 3, name: t('syncflow:orderday_03') },
    { id: 4, name: t('syncflow:orderday_04') },
    { id: 5, name: t('syncflow:orderday_05') },
    { id: 6, name: t('syncflow:orderday_06') },
    { id: 7, name: t('syncflow:orderday_07')}
  ];
  return gunler.find(g => g.id === id)?.name;
}

const OrderMonthlyPanel = (params:any) => {
  const monthlies = [
    { id: 1, description: t('syncflow:first') },
    { id: 2, description: t('syncflow:second') },
    { id: 3, description: t('syncflow:third' )},
    { id: 4, description: t('syncflow:fourth' )},
    { id: 5, description: t('syncflow:last') },
  ];

  const weeklies = Array.from({ length: 7 }, (_, i) => ({
    id: i + 1,
    description: t(`syncflow:orderday_0${i + 1}`),
  }));

const weekKeys = ['firstWeek', 'secondWeek', 'thirdWeek', 'fourthWeek', 'lastWeek'] as const;
type WeekKey = typeof weekKeys[number]; 

  type DataItem = {
    id: number;
    firstWeek?: number | null;
    secondWeek?: number | null;
    thirdWeek?: number | null;
    fourthWeek?: number | null;
    lastWeek?: number | null;
    dayName?: string | null;
  };

  const [data, setData] = useState<DataItem[]>([
    { id: 1, firstWeek: null, dayName: '' },
    { id: 2, secondWeek: null, dayName: '' },
    { id: 3, thirdWeek: null, dayName: '' },
    { id: 4, fourthWeek: null, dayName: '' },
    { id: 5, lastWeek: null, dayName: '' },
  ]);

  const dataGridRef = useRef<DataGrid>(null);
  const [popupVisible, setPopupVisible] = useState(false);

  const [selectionWeek, setSelectionWeek] = useState<number | null>(null);
  const [selectionDay, setSelectionDay] = useState<number | null>(null);

  const [rows, setRows] = useState<any[]>([]);

  const showEdit = useCallback(() => setPopupVisible(true), []);
   const onPopupHiding = () => {  
     applyChanges();  
   setPopupVisible(false);
 };
  const updateDataFromParams = () => { 
 
    const row = params.data;
    if(row.orderPeriod==='M')
    {
    const updated = data.map((item, index) => {
      const key = weekKeys[index];
      const value = row[key];
      return {
        ...item,
        [key]: value,
        dayName: value ? getDayName(value) : '',
      };
    });
    setData(updated);


  const updatedRows = updated
      .filter(item => {
        const key = weekKeys[item.id - 1];
        return item[key] != null;
      })
      .map(item => {
        const weekId = item.id;
        const dayId = item[weekKeys[weekId - 1]]!;
        return {
          id: item.id,
          weekId,
          week: monthlies.find(m => m.id === weekId)?.description ?? '',
          dayId,
          day: getDayName(dayId) ?? '',
        };
      });
    setRows(updatedRows);
  }
  };

useEffect(() => {
  if (params?.data) {
    updateDataFromParams();
  }
}, [params.data]);

const applyChanges = () => {
  const gridInstance = dataGridRef.current?.instance;
  if (!gridInstance) return;

const editData = gridInstance.option('editing.editData') as any[] || [];

  let newData = [...data];
  let newRows = [...rows];

  editData.forEach((change: any) => {
    if (change.type === 'update') {
      const weekKey = Object.keys(change.data)[0] as WeekKey;
      const weekValue = change.data[weekKey] as number;
      const id = change.key;

      const index = newData.findIndex(item => item.id === id);
      if (index !== -1) {
        newData[index][weekKey] = weekValue;
        newData[index].dayName = getDayName(weekValue);
      }
    }

    if (change.type === 'remove') {
      const id = change.key;

      const index = newRows.findIndex(row => row.id === id);
      if (index !== -1) {
        const removedRow = newRows[index];
        newRows.splice(index, 1);

        const weekId = removedRow.weekId;
        const weekKey = weekKeys[weekId - 1];
        const dataIndex = newData.findIndex(item => item.id === weekId);
        if (dataIndex !== -1) {
          newData[dataIndex][weekKey] = null;
          newData[dataIndex].dayName = '';
        }
      }
    }
  });

  setData(newData);
  setRows(newRows);

  const rowKey = params.key;
  const rowIndex = params.component.getRowIndexByKey(rowKey);
  if (rowIndex === -1) return;

  weekKeys.forEach((key) => {
    const item = newData.find(d => d.id === weekKeys.indexOf(key) + 1);
    if (item) {
      const value = item[key] ?? null;
      params.component.cellValue(rowIndex, key, value);
    }
  });

  params.component.repaintRows([rowIndex]); 

  gridInstance.option('editing.editData', []);
};

  const addRow = () => {
    if (!selectionWeek || !selectionDay) {
       toast.warning(t('syncflow:week_day_required_message'));
      return;
    }

    const exists = rows.some(r => r.weekId === selectionWeek);
    if (exists) {
      toast.warning(t('syncflow:week_error_message'));
      return;
    }

    const week = monthlies.find(m => m.id === selectionWeek);
    const day = weeklies.find(d => d.id === selectionDay);

    const newRow = {
      id: rows.length + 1,
      weekId: week?.id ?? 0,
      week: week?.description ?? '',
      dayId: day?.id ?? 0,
      day: day?.description ?? '',
    };
    setRows(prev => [...prev, newRow]);
     const updatedRows = [...rows, newRow];
    setRows(updatedRows);

  const updatedData = data.map(item => {
    if (item.id === selectionWeek) {
      const weekKey = weekKeys[selectionWeek - 1];
      return {
        ...item,
        [weekKey]: selectionDay,
        dayName: getDayName(selectionDay),
      };
    }
    return item;
  });

  setData(updatedData);
  };

  const handleDeleteRow = (e: any) => {
    const rowId = e.row?.data?.id;
    if (!rowId) return;

    const updatedRows = rows.filter(r => r.id !== rowId);
    setRows(updatedRows);

    const weekId = e.row.data.weekId;
    const weekKey = weekKeys[weekId - 1];

    const updatedData = data.map(item => {
      if (item.id === weekId) {
        return {
          ...item,
          [weekKey]: null,
          dayName: '',
        };
      }
      return item;
    });

    setData(updatedData);
  };
  const header=monthlies.map(m => (
              <td key={m.id} style={{ padding: '2px 2px' }}>{m.description}</td>
            ));

  const val=data.map(r => (
              <td key={r.id} style={{ textAlign: 'center' }}>
                <span className="badge badge-pill badge-outline badge-primary">{r.dayName}</span>
              </td>
            ));
  return (
    <>
    
      <table>
        <thead>
          <tr>
            {header}
            <td style={{padding:'2px 15px'}} rowSpan={2}>
              <Button  style={{margin:'2px 0px'}} icon="more" onClick={showEdit}/>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            {val}
          </tr>
        </tbody>
      </table>

      <Popup
        visible={popupVisible}
        onHiding={onPopupHiding}        
        hideOnOutsideClick={true}
        showCloseButton={true}        
        showTitle={true}
        width={500}
        height={500}
        position={{of: window, at: 'center',my: 'center'}}
        title={t('syncflow:order_days')}
      >
        <React.Fragment>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
          <label style={{ width: 150, marginRight: 8 }}>{t('syncflow:week_of_month')}</label>
          <SelectBox
            dataSource={monthlies}
            displayExpr="description"
            valueExpr="id"
            showClearButton
            onValueChange={(val: number | null) => setSelectionWeek(val)}
            value={selectionWeek}
            width={200}
          />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
          <label style={{ width: 150, marginRight: 8 }}> { t('syncflow:day_of_week') }</label>
          <SelectBox
            dataSource={weeklies}
            displayExpr="description"
            valueExpr="id"
            showClearButton
            onValueChange={(val: number | null) => setSelectionDay(val)}
            value={selectionDay}
            width={200}
          />
        </div>

     <div className="p-4 text-center ">
      <Button text={t('add')} onClick={addRow} />
    </div>
  
        <DataGridWrapper
            datasource={rows}
            props={{ ref: dataGridRef }}
            height={300}
            searchPanelVisible={false}
            columnChooser={false}
            editingConfig={{
              mode: "batch",
              useIcons: false,
              allowAdding: false,
              allowDeleting: false,
              allowUpdating: false,
            }}
            columns={[
              { dataField: 'id', caption: "Days", visible: false },
              { dataField: 'week', caption: t('syncflow:week_of_month'), allowEditing: true, alignment: 'center' },
              { dataField: 'day', caption: t('syncflow:day_of_week'), allowEditing: true, alignment: 'center' },
              { type: 'buttons', buttons: [{ hint: t('delete'), icon: 'trash', onClick: handleDeleteRow }] }
            ]}
          />
        </React.Fragment>
      </Popup>
    </>
  );
};

export default OrderMonthlyPanel;